const formatUINumber = (n: number): string => {
  const decimals = Math.abs(n) >= 1000 ? 0 : 2

  return (+n.toFixed(decimals)).toLocaleString()
}

export default formatUINumber
